import React from "react";

const Terms = () => {
  return (
    <>
      <section className="about py-80">
        <div className="container container-lg">
          <div className="text-center mb-64">
            <h2 className="mb-24">Terms & Conditions</h2>

            <p className="text-gray-600">
              www.airdealindia.com (the "Site") is owned and operated by Airdeal
              India Pvt. Ltd. ("we" or "us" or Airdeal India), a company
              incorporated under the laws of India and having its office at Near
              Honda City Agency, Hansi Road Barwala-125121 (Haryana) India
            </p>

            <p className="text-gray-600">
              Please note that this is a business/commercial site and can be
              accessed only by a valid account holder. Your access and use of
              the Site is subject to the following terms and conditions
              ("Website Terms and Conditions") and all applicable laws. By
              accessing and browsing this Site, you accept, without limitation
              or qualification, the Website Terms and Conditions. If you do not
              agree with any of the below Terms and Conditions, do not use this
              Site. We reserve the right, in our sole discretion, to modify,
              alter or otherwise update these Website Terms and Conditions at
              any time and you agree to be bound by such modifications,
              alterations or updates.
            </p>
            <p className="text-gray-600">
              INTENDED AUDIENCEUnless otherwise specified, this site is intended
              for two categories of people i.e.
            </p>
            <p className="text-gray-600">Airdeal India</p>
            <p className="text-gray-600">Customers</p>
          </div>

          <div className="row gy-4">
            <div className="col-lg-12">
              <div className="border border-gray-100 rounded-16 p-32">
                <p className="mb-24 text-gray-700">
                  Each category in turn is bound by an additional agreement i.e.
                  a Airdeal India is bound by the "Airdeal India agreement"; and
                  a Customer is bound by the "Customer agreement". These
                  agreements find mention on the relevant portions of the
                  website that relate to each of these categories. If you fall
                  within any of these categories, it is your responsibility to
                  familiarise yourself with the appropriate agreement and to
                  comply with its terms.
                </p>
                <p className="mb-24 text-gray-700">
                  This website (operated by us from our office located in
                  Jaipur, India) is intended as a service to the above mentioned
                  categories of people located in India. Therefore any person
                  who accesses this website from outside India shall do so at
                  his/her own risk and is responsible for compliance with the
                  laws of his/her respective jurisdiction.
                </p>
                <p className="mb-24 text-gray-700">
                  No Cosmetics or Healthcare AdviceThe products, information,
                  services and other content provided on and through this site,
                  including without limitation any products, information,
                  services and other content provided on any Linked Site, are
                  provided for informational purposes only to facilitate
                  discussions with your beauticians or other healthcare
                  professional (collectively, "Cosmetics Professional")
                  regarding use options.{" "}
                </p>
                <p className="mb-24 text-gray-700">
                  The information provided on this site and Linked Sites,
                  including without limitation information relating to products
                  and treatments is often provided in summary or aggregate form.
                  It is not intended as a substitute for advice from your
                  Cosmetic Professional, or any information contained on or in
                  any product label or packaging. No healthcare advice,
                  recommendation, or opinion is offered on this web site.
                </p>

                <p className="mb-24 text-gray-700">
                  REFUND POLICYWe are confident of the products we sell, are
                  well know branded products and we give a FULL MONEY BACK
                  GUARANTEE within 30 days of invoice date. If you are not
                  satisfied with any product you may return it back to us and
                  you will qualify for a full refund, minus shipping.
                </p>

                <div className="bg-main-50 rounded-16 p-24 mt-40 mb-40">
                  <h4 className="mb-20 text-main-600">
                    Refunds Terms & Conditions:
                  </h4>

                  <p className="text-gray-700 mb-24 ">
                    We do not accept payment if refund needs to be desperate, if
                    refund requested after delivery then werefund within 5 days
                    of product returned back to us.
                  </p>
                  <p className="text-gray-700 mb-24 ">
                    Refund only possible if, the product is delivered back &
                    shipment cost to be borne by the customer.
                  </p>
                  <p className="text-gray-700 mb-24 ">
                    If the goods are delivered in the damaged condition to the
                    customer, then the shipping cost is to be borne by the
                    company. And we will reship the product.
                  </p>
                  <p className="text-gray-700 mb-24 ">
                    Mode of refund would be credit card refund.
                  </p>
                  <p className="text-gray-700 mb-24 ">
                    No Exchange Policy Customer can send product back and claim
                    refund.
                  </p>
                  <p className="text-gray-700 mb-24 ">
                    No Cancellation Policy If, customer cancels midway after
                    product shipped they will have the ship it back and claim
                    refund.
                  </p>
                  <p className="text-gray-700 mb-24 ">
                    If the product needs to be cancelled due to any reason prior
                    the receipt, shipping charges will not be charged if product
                    not shipped at that point of time.
                  </p>
                  <p className="text-gray-700 mb-24 ">
                    NTELLECTUAL PROPERTY RIGHTS
                  </p>
                </div>

                <div className="bg-main-50 rounded-16 p-24 mt-40 mb-40">
                  <h4 className="mb-20 text-main-600">Copyrights</h4>

                  <p className="text-gray-700 mb-24 ">
                    All material on this Site ("Material"), including but not
                    limited to text, images, illustrations, etc are protected by
                    copyrights which are owned and controlled by us or by other
                    parties that have licensed their material to us.{" "}
                  </p>
                  <p className="text-gray-700 mb-24 ">
                    Material from the site may not be copied, reproduced,
                    republished, uploaded, posted, transmitted, or distributed
                    in any way.
                  </p>
                  <p className="text-gray-700 mb-24 ">
                    We grant you a limited license to access and make personal
                    use of this site and not to download (other than page
                    caching) or modify it, or any portion of it, except with the
                    written consent of Airdeal India. This license does not
                    include any resale or commercial use of this site or its
                    contents; any collection and use of any product listings,
                    descriptions, or prices; any derivative use of this site or
                    its contents; any downloading or copying of account
                    information for the benefit of another merchant; or any use
                    of data mining, robots, or similar data gathering and
                    extraction tools.{" "}
                  </p>
                  <p className="text-gray-700 mb-24 ">
                    You may not frame or utilise framing techniques to enclose
                    any trademark, logo, or other proprietary information
                    (including images, text, page layout, or form) of Airdeal
                    India without express written consent. You may not use any
                    meta tags or any other "hidden text" utilising Airdeal India
                    name or trademarks without the express written consent of
                    Airdeal India. Any unauthorised use terminates the
                    permission or license granted by Airdeal India.{" "}
                  </p>
                  <p className="text-gray-700 mb-24 ">
                    You are grated a limited, revocable and nonexclusive right
                    to create a hyperlink to the home page of Airdeal India so
                    long as the link does not portray Airdeal India, its
                    affiliates, or their products or services in a false,
                    misleading, derogatory, or otherwise offensive matter. You
                    may not use any Airdeal India logo or other proprietary
                    graphic or trademark as part of the link without express
                    written permission.
                  </p>
                </div>

                <div className="bg-main-50 rounded-16 p-24 mt-40 mb-40">
                  <h4 className="mb-20 text-main-600">Trademarks </h4>

                  <p className="text-gray-700 mb-24 ">
                    The trademarks, logos and service marks ("Marks") displayed
                    on the Site are our property and the property of other
                    parties. Users are prohibited from using any Marks without
                    our written permission or third parties, which may own the
                    Marks. We also own "trade-dress" rights to the look and feel
                    of our website, which cannot be replicated, without our
                    permission.
                  </p>

                  <p className="text-gray-700 mb-24 ">
                    SUBMISSIONS OF INFORMATION/IDEASAny information or material
                    submitted by you to the Airdeal India website (whether
                    through e-mail or otherwise) will be deemed non-proprietary
                    and non-confidential, and may be used by Airdeal India
                    without restriction. Notwithstanding the foregoing, all
                    personal data (e.g., name, address and telephone number)
                    provided to Airdeal India will be handled in accordance with
                    Airdeal India Privacy Policy.{" "}
                  </p>
                  <p className="text-gray-700 mb-24 ">
                    Airdeal India is always improving its products and services
                    and developing new features. If you have ideas regarding
                    improvements or additions to the Airdeal India, we would
                    like to hear them. However, please note that under no
                    circumstances shall any disclosure of any idea, related
                    materials to Airdeal India be subject to any obligation of
                    confidentiality or expectation of compensation.{" "}
                  </p>
                  <p className="text-gray-700 mb-24 ">
                    By submitting the idea and/or any related material to
                    Airdeal India, you are waiving any/all rights that you may
                    have in the idea or any related materials and are
                    representing and warranting to Airdeal India that the idea
                    and/or related materials are wholly original with you and
                    that no one else has any rights in the idea and/or materials
                    and that Airdeal India is free to implement that idea and to
                    use the materials if it so desires as provided or as
                    modified by Airdeal India, without obtaining permission or
                    license from any third party.
                  </p>

                  <p className="text-gray-700 mb-24 ">
                    LINKED SITESWe may provide links and pointers to Internet
                    sites maintained by others ("Third Party Sites"). We are not
                    responsible for the contents of or any products or services
                    offered in such Third Party Sites.
                  </p>

                  <p className="text-gray-700 mb-24 ">
                    DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITYThis
                    site is provided by Airdeal India on an "as is and "as
                    available" basis. Airdeal India makes no representations or
                    warranties of any kind, express or implied, as to the
                    operation of this site or the information, content,
                    materials, or products included on this site. You expressly
                    agree that your use of this site is at your sole risk. To
                    the full extent permissible by applicable law, Airdeal India
                    disclaims all warranties, express or implied, including, but
                    not limited to, implied warranties of merchantability and
                    fitness for a particular purpose.{" "}
                  </p>
                  <p className="text-gray-700 mb-24 ">
                    Airdeal India does not warrant that this site, its servers,
                    or e-mail sent from Airdeal India are free of viruses or
                    other harmful components. Airdeal India will not be liable
                    for any damages of any kind arising from the use of this
                    site, including, but not limited to direct, indirect,
                    incidental, punitive, and consequential damages.
                  </p>

                  <p className="text-gray-700 mb-24 ">
                    LIMITATION OF REMEDYIf you are damaged or injured by any of
                    the Material contained in the Site, or you are dissatisfied
                    with the Site or Material for any reason, then your sole and
                    exclusive remedy is to discontinue accessing and using the
                    Site.
                  </p>

                  <p className="text-gray-700 mb-24 ">
                    JURISDICTIONAL ISSUESThis agreement shall be governed by,
                    construed and enforced solely in accordance with the laws of
                    the India and the courts at Delhi shall have exclusive
                    jurisdiction in this regard. This is the entire agreement
                    between the parties relating to the matters contained
                    herein.
                  </p>

                  <p className="text-gray-700 mb-24 ">
                    TERMINATIONThis agreement will terminate immediately without
                    notice from us if in our sole discretion you fail to comply
                    with any term or provision of this Agreement. Upon
                    termination, you must destroy all materials obtained from
                    this Site and all copies thereof, whether made under the
                    terms of this Agreement or otherwise. In the event of
                    termination, the disclaimers of warranties and limitations
                    of liabilities, damages and remedies set forth in this
                    Agreement shall survive.
                  </p>

                  <p className="text-gray-700 mb-24 ">
                    OTHERIf any provision of this agreement shall be unlawful,
                    void, or for any reason unenforceable then that provision
                    shall be deemed severable from this agreement and shall not
                    affect the validity and enforceability of any remaining
                    provisions. We may at any time revise these Terms and
                    Conditions by updating this posting. You are bound by any
                    such revisions and should therefore periodically visit this
                    page to review the then current Terms and Conditions to
                    which you are bound.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Terms;
